<template>
  <v-menu menu-props="offsetY">
    <v-btn
      slot="activator"
      small
      color="primary"
      dark
      :loading="loading"
      class="mx-0"
    >
      {{ currentState.title }}
      <v-icon
        right
        small
      >
        keyboard_arrow_down
      </v-icon>
    </v-btn>
    <v-list>
      <v-list-tile
        v-for="state in filteringStates"
        :key="state.id"
        @click="changeState(state)"
      >
        <v-list-tile-title>{{ state.title }}</v-list-tile-title>
      </v-list-tile>
      <v-list-tile
        v-if="isDeleteRoute"
        @click="deleteRoute"
      >
        <v-list-tile-title>Отменен</v-list-tile-title>
      </v-list-tile>
    </v-list>
  </v-menu>
</template>
<script>
import { deleteRoute } from "../../../backend/routesApi.js";
export default {
  props: ["id", "resource", "isDeleteRoute"],
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    states() {
      return this.$store.getters["enums/items"]("route-states");
    },
    currentState() {
      return this.$store.getters[`${this.resource}/getState`];
    },
    filteringStates() {
      if (!this.currentState) {
        return this.states;
      }
      return this.states.filter(s => s.id !== this.currentState.id);
    },
  },
  async created() {
    await this.$store.dispatch("enums/getItems", "route-states");
  },
  methods: {
    async changeState(newState) {
      this.$store.commit(`${this.resource}/setState`, newState);
      try {
        this.loading = true;
        await this.$store.dispatch("route/changeState", {
          id: this.id,
          newState,
        });
        this.loading = false;
        this.showInfo("Статус изменен");
      } catch (error) {
        if (error.message) {
          this.loading = false;
          this.showError(error.message);
        } else {
          this.loading = false;
          throw error;
        }
      }
    },
    async deleteRoute() {
      if (confirm("Маршрут будет удален?")) {
        this.loading = true;
        const res = await deleteRoute(this.id);
        this.loading = false;
        if (res) {
          this.$router.go(-1);
        }
      }
    },
  },
};
</script>
